/**
 * 舞台元素事件类型
 * @type {string}
 */
const ELEMENT_ADD = "ELEMENT_ADD" // 新增元素
const CHANGE_VDR_OPTIONS = "CHANGE_VDR_OPTIONS" // 修改vue-draggible-resizable的属性
const UPDATE_RECT_MODULE_ID_TYPE_ID = "UPDATE_RECT_MODULE_ID_TYPE_ID" // 更新组件的moduleId和typeId
const UPDATE_CREATE_BLOCK_TIMES = "UPDATE_CREATE_BLOCK_TIMES" // 更新控制布局组件app端转换控制属性
const ELEMENT_DELETE = "ELEMENT_DELETE" // 删除元素
const ENABLE_ACTIVE = "ENABLE_ACTIVE" // 选中
const DISABLE_ACTIVE = "DISABLE_ACTIVE" // 取消选中
const CHANGE_WIDTH = "CHANGE_WIDTH" // 改变宽度
const CHANGE_HEIGHT = "CHANGE_HEIGHT" // 改变高度
const CHANGE_TOP = "CHANGE_TOP" // 改变top位置
const CHANGE_LEFT = "CHANGE_LEFT" // 改变left位置
const CHANGE_DRAGGABLE = "CHANGE_DRAGGABLE" //改变组件的可拖动状态
const CHANGE_OPTION = "CHANGE_OPTION" //改变选项
const CHANGE_OPTIONS = "CHANGE_OPTIONS" //改变选项
const CHANGE_STORE_OPTIONS = "CHANGE_STORE_OPTIONS" //改变备份选项
const CHANGE_STORE_OPTIONS_NEW = "CHANGE_STORE_OPTIONS_NEW" //改变备份选项
const INIT_STORE_OPTIONS = "INIT_STORE_OPTIONS" // 初始化备份选项
const SWIPER_CONTENT_CONTROL = "SWIPER_CONTENT_CONTROL" //新增选项内容
const SWIPER_CONTENT_OPTIONS_UPDATE = "SWIPER_CONTENT_OPTIONS_UPDATE" //轮播改变每项的options
const SWIPER_CONTENT_UPDATE = "SWIPER_CONTENT_UPDATE"
const DEL_OPTION_CONTENT = "DEL_OPTION_CONTENT" //删除选项内容
const CHANGE_LAYOUT_OPTION = "CHANGE_LAYOUT_OPTION" //修改布局组件内列组件内的组件
const ADD_COMPONENT_IN_LAYOUT = "ADD_COMPONENT_IN_LAYOUT" //在布局组件中拖拽添加组件
const ADD_COMPONENT_IN_LAYOUT_AROUND = "ADD_COMPONENT_IN_LAYOUT_AROUND" //在布局组件四周中拖拽添加组件
const CHANGE_LAYOUT_SIZE = "CHANGE_LAYOUT_SIZE" //修改布局组件内列组件内组件的size
const CHANGE_LAYOUT_ACTIVE = "CHANGE_LAYOUT_ACTIVE" //修改布局组件内列组件内组件的size
const INIT_LAYOUT_COMPONENT = "INIT_LAYOUT_COMPONENT" //初始化布局组件中的布局
const CHANGE_LAYOUT_TITLE_OPTIONS = "CHANGE_LAYOUT_TITLE_OPTIONS" //修改布局组件内标题配置项
const CHANGE_LAYOUT_TITLE_ElEMENT = "CHANGE_LAYOUT_TITLE_ElEMENT" //修改布局组件内标题的组件，主要用于兼容自由布局以前没有更多和分页组件的情况
const CHANGE_LAYOUT_TITLE_ACTIVE = "CHANGE_LAYOUT_TITLE_ACTIVE" //修改布局组件内标题激活状态
const CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE = "CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE" //修改布局组件内标题激活状态
const CHANGE_LAYOUT_TITLE_DISPLAY = "CHANGE_LAYOUT_TITLE_DISPLAY" //修改布局组件内显示相关的4个设置
const CHANGE_LAYOUT_TITLE_DISPLAY_SHOW = "CHANGE_LAYOUT_TITLE_DISPLAY_SHOW" //修改布局组件内显示相关的4个设置是否显示
const CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE = "CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE" //修改布局组件内显示相关的4个设置
const CHANGE_LAYOUT_COMPONENTBOX_OPTION = "CHANGE_LAYOUT_COMPONENTBOX_OPTION" //修改布局组件中col.elementOptions中的所有组件
const CHANGE_LAYOUT_CELL_BOX_OPTION_SIZE = "CHANGE_LAYOUT_CELL_BOX_OPTION_SIZE" //限制布局组件中col.elementOptions中的所有组件在单元格内
const CHANGE_ROW_COL_SIZE = "CHANGE_ROW_COL_SIZE" //修改布局组件行列的大小
const CHANGE_ROW_COL_UID = "CHANGE_ROW_COL_UID" //修改布局组件行列的uid

const ADD_LAYOUT_BLOCK = "ADD_LAYOUT_BLOCK" //在布局组件中动态添加块
const RESET_LAYOUT_BLOCK = "RESET_LAYOUT_BLOCK" // 重置布局组件内容
const DEL_LAYOUT_COL = "DEL_LAYOUT_COL" //在布局组件中删除列
const PASTE_LAYOUT_COL = "PASTE_LAYOUT_COL" //在布局组件中复制列
const ADD_LAYOUT_COL = "ADD_LAYOUT_COL" //在布局组件中新增列
const EXCHANGE_LAYOUT_COL = "EXCHANGE_LAYOUT_COL" //在布局组件中交换列
const CHANGE_DATASOURCE = "CHANGE_DATASOURCE" //修改数据源
const DEL_LAYOUT_ELEMENT = "DEL_LAYOUT_ELEMENT" //删除布局组件中的元素
const DEL_LAYOUT_AROUND_ELEMENT = "DEL_LAYOUT_AROUND_ELEMENT" //删除布局组件四周中的元素
const CHANGE_TABS_ACTIVE_INDEX = "CHANGE_TABS_ACTIVE_INDEX" //改变布局组件中的tabs中的激活index
const CHANGE_ANCHOR_ACTIVE_INDEX = "CHANGE_ANCHOR_ACTIVE_INDEX" //改变锚点激活index
const CHANGE_TABS_TITLE = "CHANGE_TABS_TITLE" //改变布局组件中的tabs中的内容
const CHANGE_TAB_MAP_ROW_CONTENT = "CHANGE_TAB_MAP_ROW_CONTENT" //改变布局组件中的tab对应row的内容
const CHANGE_TABS_ORDER = "CHANGE_TABS_ORDER" //调整布局和通栏中tab的顺序
const UPDATE_COLS_OPTION = "UPDATE_COLS_OPTION" //更新布局组件中的cols的属性
const UPDATE_COL_LEN_IN_LAYOUT = "UPDATE_COL_LEN_IN_LAYOUT" //加减布局组件中的列
const UPDATE_ROW_LEN_IN_LAYOUT = "UPDATE_ROW_LEN_IN_LAYOUT" //加减布局组件中的行
const UPDATE_TREE_DATA = "UPDATE_TREE_DATA" // 在组件发生增删后更新左侧图层的树形结构
const INIT_TREE_DATA = "INIT_TREE_DATA" // 初始化图层树结构

const CHANGE_LAYOUT_BLOCK_SIZE = "CHANGE_LAYOUT_BLOCK_SIZE" // 改变布局组件中块的尺寸
const CHANGE_BAYWINDOW_STATUS = "CHANGE_BAYWINDOW_STATUS" // 修改飘窗状态

/**
 * 布局分类事件类型
 */
const CHANGE_LAYOUT_TABS_LENGTH = "CHANGE_LAYOUT_TABS_LENGTH" //改变布局分类数量
const INIT_LAYOUT_OTHERS = "INIT_LAYOUT_OTHERS" //根据数据初始化布局的标题，副标题，更多，分类名称
const CHANGE_LAYOUT_BLOCK_BY_TABS = "CHANGE_LAYOUT_BLOCK_BY_TABS" //将所有分类对应的row的组件替换成第一个分类下的rows的组件

/**
 * 轮播组件内部布局组件事件
 */
const CHANGE_ELEMENT_IN_SWIPER_ACTIVE = "CHANGE_ELEMENT_IN_SWIPER_ACTIVE" //设置轮播组件内单页中组件的active
const ADD_ELEMENT_IN_SWIPER = "ADD_ELEMENT_IN_SWIPER" //轮播组件页内添加组件
const DEL_ELEMENT_IN_SWIPER = "DEL_ELEMENT_IN_SWIPER" //轮播组件页内删除组件
const CHANGE_SWIPER_OPTIONS = "CHANGE_SWIPER_OPTIONS" //更新轮播组件页内的组件的options
const CHANGE_SWIPER_CONTENT_OPTIONS = "CHANGE_SWIPER_CONTENT_OPTIONS" //更新轮播组件页内的options
/**
 * 自动布局组件内部事件
 */
const ADD_COMPONENT_IN_AUTOLAYOUT = "ADD_COMPONENT_IN_AUTOLAYOUT" //在自动布局组件中拖拽添加组件
const CHANGE_ELEMENT_IN_AUTOLAYOUT_ACTIVE = "CHANGE_ELEMENT_IN_AUTOLAYOUT_ACTIVE" //在自动布局组件中拖拽添加组件
const CHANGE_ELEMENT_IN_AUTOLAYOUT_UNACTIVE = "CHANGE_ELEMENT_IN_AUTOLAYOUT_UNACTIVE" //在自动布局组件中拖拽添加组件
const DEL_ELEMENT_IN_AUTOLAYOUT = "DEL_ELEMENT_IN_AUTOLAYOUT" //自动布局组件页内删除组件
const CHANGE_AUTOLAYOUT_OPTIONS = "CHANGE_AUTOLAYOUT_OPTIONS" //更新自动布局组件页内的组件的options
/**
 * 数据列表组件内部事件
 */
const ADD_COMPONENT_IN_DATAGRID = "ADD_COMPONENT_IN_DATAGRID" //在数据列表组件中拖拽添加组件
const CHANGE_ELEMENT_IN_DATAGRID_ACTIVE = "CHANGE_ELEMENT_IN_DATAGRID_ACTIVE"
const CHANGE_ELEMENT_IN_DATAGRID_UNACTIVE = "CHANGE_ELEMENT_IN_DATAGRID_UNACTIVE"
const DEL_ELEMENT_IN_DATAGRID = "DEL_ELEMENT_IN_DATAGRID" //数据列表组件页内删除组件
const CHANGE_DATAGRID_OPTIONS = "CHANGE_DATAGRID_OPTIONS" //更新数据列表组件页内的组件的options
const CHANGE_DATAGRID_LAYOUT = "CHANGE_DATAGRID_LAYOUT" //更新数据列表组件的布局结构

/**
 * 页面布局组件内部事件
 */
const CHANGE_PAGE_LAYOUT = "CHANGE_PAGE_LAYOUT" // 改变画布中布局
const CHANGE_PAGE_LAYOUT_ROW = "CHANGE_PAGE_LAYOUT_ROW" // 加减画布中布局的row
const INSERT_PAGE_LAYOUT = "INSERT_PAGE_LAYOUT" // 加减画布中布局的row
const CHANGE_PAGE_LAYOUT_TABS_LENGTH = "CHANGE_PAGE_LAYOUT_TABS_LENGTH" // 修改通栏画布中指定分类数量

/**
 * 舞台事件类型
 * @type {string}
 */
const CONTAINER_DELETE = "CONTAINER_DELETE" // 删除容器
const CONTAINER_SORT = "CONTAINER_SORT" // 容器排序
const ENABLE_CONTAINER_ACTIVE = "ENABLE_CONTAINER_ACTIVE" // 选中容器
const DISABLE_CONTAINER_ACTIVE = "DISABLE_CONTAINER_ACTIVE" // 取消选中容器
const CHANGE_CONTAINER_SIZE = "CHANGE_CONTAINER_SIZE" // 修改容器大小
const CHANGE_CONTAINER_DATA = "CHANGE_CONTAINER_DATA" // 修改容器数据
const COUNT_CONTAINER_HEIGHT = "COUNT_CONTAINER_HEIGHT" // 计算容器的高度
const INSERT_CONTAINER = "INSERT_CONTAINER" // 插入容器
const CHANGE_CONTAINER_POSITION = "CHANGE_CONTAINER_POSITION" // 容器位置交换
const CHANGE_ATTRIBUTE = "CHANGE_ATTRIBUTE" // 改变其他属性值
const CHANGE_PAGE_TYPE = "CHANGE_PAGE_TYPE" // 改变页面类型
const CHANGE_CONTAINER_ATTRIBUTE = "CHANGE_CONTAINER_ATTRIBUTE" // 改变画布他属性值
const CHANGE_STAGE_LAYOUT_OPTION = "CHANGE_STAGE_LAYOUT_OPTION" // 改变布局画布树的属性

/**
 * 二三级页面事件类型
 */
const CHANGE_LIST_PAGE_SETTING = "CHANGE_LIST_PAGE_SETTING" // 改变列表页中的配置项属性
const CHANGE_DETAIL_PAGE_SETTING = "CHANGE_DETAIL_PAGE_SETTING" // 改变详情页中的配置项属性
const CHANGE_SUB_PAGE_MAPPING = "CHANGE_SUB_PAGE_MAPPING" // 改变子页面映射关系
const CHANGE_PHONE_FULL_SCREEN = "CHANGE_PHONE_FULL_SCREEN" // 改变翻页模版标识
const CHANGE_PAGE_LAYOUT_TYPE = "CHANGE_PAGE_LAYOUT_TYPE" // 改变当前页面的类型 是否为布局模式
const CHANGE_ONLY_H5_TEMPLATE = "CHANGE_ONLY_H5_TEMPLATE" // 修改是否是独立的移动端

/**
 * 前后端接口联调
 */
const ADD_APPID = "ADD_APPID" // 添加appid
const UPDATE_APPID = "UPDATE_APPID" // 在rect中添加appid
const DEL_APPID = "DEL_APPID" // 删除appid
const INIT_STAGE_DATA = "INIT_STAGE_DATA" // 初始化webjson
const CHANGE_VERSION = "CHANGE_VERSION" // 更新version
const CHANG_BIG_SCREEN_OPTION = "CHANG_BIG_SCREEN_OPTION" // 更新charoption
const CLEAR_ALL_RECT = "CLEAR_ALL_RECT" // 清空所有的rect
export default {
  ELEMENT_ADD,
  CHANGE_VDR_OPTIONS,
  CHANG_BIG_SCREEN_OPTION,
  CLEAR_ALL_RECT,
  UPDATE_RECT_MODULE_ID_TYPE_ID,
  UPDATE_CREATE_BLOCK_TIMES,
  ELEMENT_DELETE,
  CONTAINER_DELETE,
  CONTAINER_SORT,
  ENABLE_ACTIVE,
  DISABLE_ACTIVE,
  CHANGE_WIDTH,
  CHANGE_HEIGHT,
  CHANGE_TOP,
  CHANGE_LEFT,
  CHANGE_DRAGGABLE,
  CHANGE_OPTION,
  CHANGE_OPTIONS,
  CHANGE_STORE_OPTIONS,
  CHANGE_STORE_OPTIONS_NEW,
  INIT_STORE_OPTIONS,
  SWIPER_CONTENT_CONTROL,
  SWIPER_CONTENT_OPTIONS_UPDATE,
  SWIPER_CONTENT_UPDATE,
  DEL_OPTION_CONTENT,
  CHANGE_LAYOUT_OPTION,
  ADD_COMPONENT_IN_LAYOUT,
  ADD_COMPONENT_IN_LAYOUT_AROUND,
  ADD_COMPONENT_IN_AUTOLAYOUT,
  CHANGE_LAYOUT_ACTIVE,
  INIT_LAYOUT_COMPONENT,
  CHANGE_LAYOUT_TITLE_OPTIONS,
  CHANGE_LAYOUT_TITLE_ElEMENT,
  CHANGE_LAYOUT_TITLE_DISABLE_ACTIVE,
  CHANGE_LAYOUT_TITLE_DISPLAY,
  CHANGE_LAYOUT_TITLE_DISPLAY_SHOW,
  CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE,
  CHANGE_LAYOUT_TITLE_ACTIVE,
  CHANGE_LAYOUT_SIZE,
  CHANGE_DATASOURCE,
  ADD_LAYOUT_BLOCK,
  RESET_LAYOUT_BLOCK,
  DEL_LAYOUT_COL,
  PASTE_LAYOUT_COL,
  ADD_LAYOUT_COL,
  EXCHANGE_LAYOUT_COL,
  DEL_LAYOUT_ELEMENT,
  DEL_LAYOUT_AROUND_ELEMENT,
  CHANGE_TABS_ACTIVE_INDEX,
  CHANGE_ANCHOR_ACTIVE_INDEX,
  CHANGE_TABS_TITLE,
  CHANGE_TAB_MAP_ROW_CONTENT,
  CHANGE_TABS_ORDER,
  ENABLE_CONTAINER_ACTIVE,
  DISABLE_CONTAINER_ACTIVE,
  CHANGE_CONTAINER_SIZE,
  CHANGE_CONTAINER_DATA,
  COUNT_CONTAINER_HEIGHT,
  INSERT_CONTAINER,
  CHANGE_CONTAINER_POSITION,
  ADD_APPID,
  UPDATE_APPID,
  DEL_APPID,
  INIT_STAGE_DATA,
  CHANGE_VERSION,
  CHANGE_ATTRIBUTE,
  CHANGE_CONTAINER_ATTRIBUTE,
  CHANGE_STAGE_LAYOUT_OPTION,
  CHANGE_LAYOUT_TABS_LENGTH,
  UPDATE_COLS_OPTION,
  INIT_LAYOUT_OTHERS,
  CHANGE_ELEMENT_IN_SWIPER_ACTIVE,
  CHANGE_ELEMENT_IN_AUTOLAYOUT_ACTIVE,
  CHANGE_ELEMENT_IN_AUTOLAYOUT_UNACTIVE,
  DEL_ELEMENT_IN_AUTOLAYOUT,
  CHANGE_AUTOLAYOUT_OPTIONS,
  ADD_ELEMENT_IN_SWIPER,
  DEL_ELEMENT_IN_SWIPER,
  CHANGE_SWIPER_OPTIONS,
  CHANGE_SWIPER_CONTENT_OPTIONS,
  UPDATE_COL_LEN_IN_LAYOUT,
  UPDATE_ROW_LEN_IN_LAYOUT,
  UPDATE_TREE_DATA,
  INIT_TREE_DATA,
  CHANGE_LAYOUT_BLOCK_SIZE,
  CHANGE_LAYOUT_COMPONENTBOX_OPTION,
  CHANGE_LAYOUT_CELL_BOX_OPTION_SIZE,
  CHANGE_ROW_COL_SIZE,
  CHANGE_ROW_COL_UID,
  CHANGE_LIST_PAGE_SETTING,
  CHANGE_DETAIL_PAGE_SETTING,
  CHANGE_PAGE_LAYOUT,
  CHANGE_PAGE_LAYOUT_ROW,
  INSERT_PAGE_LAYOUT,
  CHANGE_SUB_PAGE_MAPPING,
  CHANGE_PAGE_LAYOUT_TABS_LENGTH,
  CHANGE_BAYWINDOW_STATUS,
  CHANGE_LAYOUT_BLOCK_BY_TABS,
  CHANGE_PHONE_FULL_SCREEN,
  CHANGE_PAGE_LAYOUT_TYPE,
  CHANGE_ONLY_H5_TEMPLATE,
  CHANGE_PAGE_TYPE,
  ADD_COMPONENT_IN_DATAGRID,
  CHANGE_ELEMENT_IN_DATAGRID_ACTIVE,
  CHANGE_ELEMENT_IN_DATAGRID_UNACTIVE,
  DEL_ELEMENT_IN_DATAGRID,
  CHANGE_DATAGRID_OPTIONS,
  CHANGE_DATAGRID_LAYOUT
}
